module.exports = __webpack_public_path__ + "img/组 129@2x.5a666357.png";